import { ref, reactive } from 'vue';
import store from '@/store';

export function usePreventaListado(eventoId) {
    const loading = ref(false);
    const loadingReenvio = ref(false);
    const loadingEntradasPrevistas = ref(false);
    const loadingEntradasCompradas = ref(false);
    const registros = ref({});
    const entradasPrevistas = ref(0);
    const entradasCompradas = ref(0);

    const filters = reactive({
        search: '',
        sortBy: 'created_at',
        order: 'desc',
        per_page: 10,
        page: 1,
        status: '',
        evento_id: eventoId
    });

    const filtersEntradasPrevistas = reactive({
        estado: { label: 'Aprobado', value: 'selected' }
    });

    const getSearchParams = () => {
        const params = {
            evento_id: eventoId,
            filters: {
                perPage: filters.per_page,
                page: filters.page,
                sortBy: filters.sortBy,
                order: filters.order
            }
        };

        if (filters.search) params.filters.search = filters.search;
        if (filters.status) params.filters.status = filters.status;

        return params;
    };
    const getRegistrosPreventa = async() => {
        loading.value = true;

        try {
            const res = await store.dispatch(
                'BACK_EVENTS_PREVENTA_LISTADO',
                getSearchParams()
            );

            registros.value = res.data;
        } catch (error) {
            console.error('Error al cargar registros preventa:', error);
        } finally {
            loading.value = false;
        }
    };

    const getEntradasPrevistas = async() => {
        loadingEntradasPrevistas.value = true
        const filtros = {
            evento_id: eventoId,
            filters: {
                estado: filtersEntradasPrevistas.estado.value
            }
        }

        try {
            const res = await store.dispatch('BACK_EVENTS_PREVENTA_ENTRADAS_PREVISTAS', filtros);

            entradasPrevistas.value = res.data.total_entradas_previstas || 0;
        } catch (error) {
            console.error('Error al cargar entradas previstas:', error);
        } finally {
            loadingEntradasPrevistas.value = false;
        }
    };

    const getEntradasCompradas = async() => {
        loadingEntradasCompradas.value = true

        try {
            const res = await store.dispatch(
                'BACK_EVENTS_PREVENTA_ENTRADAS_COMPRADAS',
                { evento_id: eventoId }
            );

            entradasCompradas.value = res.data.total_entradas_compradas || 0;
        } catch (error) {
            console.error('Error al cargar entradas compradas:', error);
        } finally {
            loadingEntradasCompradas.value = false;
        }
    };

    const reenviarCorreo = async registro_id => {
        loadingReenvio.value = true;

        const params = {
            evento_id: eventoId,
            registro_id: registro_id
        }

        try {
            await store.dispatch('BACK_EVENTS_PREVENTA_REENVIAR_EMAIL', params);
        } catch (error) {
            console.error('Error al cargar registros preventa:', error);
        } finally {
            loadingReenvio.value = false;
        }
    };
    const getBadgeClass = status => {
        const classes = {
            pending: 'badge badge-warning p-2',
            selected: 'badge badge-success p-2',
            rejected: 'badge badge-danger p-2',
            purchased: 'badge badge-primary p-2'
        };
        return classes[status] || 'badge badge-secondary';
    };
    const getStatusLabel = status => {
        const labels = {
            pending: 'Pendiente',
            selected: 'Aprobada',
            rejected: 'Denegada',
            purchased: 'Comprada'
        };
        return labels[status] || status;
    };
    return {
        filters,
        filtersEntradasPrevistas,
        loading,
        loadingReenvio,
        loadingEntradasPrevistas,
        loadingEntradasCompradas,
        registros,
        entradasPrevistas,
        entradasCompradas,
        getRegistrosPreventa,
        getEntradasPrevistas,
        getEntradasCompradas,
        getBadgeClass,
        getStatusLabel,
        reenviarCorreo
    };
}